import Head from 'next/head';

export const BRAND_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Orbitron:wght@500;700;800;900&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap';

/** Orbitron, Inter and JetBrains Mono, for the Rive brand look. */
export default function BrandFonts() {
  // Keys let next/head drop the copy when a page and its layout both add these.
  return (
    <Head>
      <link
        key="brand-fonts-preconnect"
        rel="preconnect"
        href="https://fonts.googleapis.com"
      />
      <link
        key="brand-fonts-preconnect-static"
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link key="brand-fonts" rel="stylesheet" href={BRAND_FONTS_HREF} />
    </Head>
  );
}
